import { getMessages } from '../../../../../store/constants';

export const CLASS_AFTER_SKIP_DIALOG= 'after-skip-dialog';

export const AFTER_SKIP_DIALOG_TITLE = getMessages().getText('after_skip_dialog.title');
export const AFTER_SKIP_DIALOG_SUBTITLE = getMessages().getText('after_skip_dialog.subTitle');
export const AFTER_SKIP_DIALOG_YES = getMessages().getText('after_skip_dialog.yes');
export const AFTER_SKIP_DIALOG_NO = getMessages().getText('after_skip_dialog.no');
